import React from 'react';
import PropTypes from 'prop-types';

const icons = require.context('../assets/images/icons/', true);

const ContentGrid = (props) => {
  const {
    content,
    offset,
  } = props;

  let img;
  return (
    <div className={`ContentGrid ContentGrid__num-${content.blocks.length}`}>
      {content.headline ? <h3 className="ContentGrid__Headline">{content.headline}</h3> : null}
      <div className={`ContentGrid__Blocks Gridblock${offset ? ` Gridblock-offset-${offset}`: ''}`}>
        {content.blocks.map((v) => {
          return (
            <div key={`Gridblock-Item-${v.headline}`} className="Gridblock__Wrapper">
              <div className="Gridblock__ImageWrapper">
                <img className="Gridblock__Image" alt="tester" src={icons(`./${v.icon}.svg`)} />
              </div>
              <h4 className="Gridblock__Heading">{v.headline}</h4>
              <p dangerouslySetInnerHTML={{ __html: v.content }} className="Gridblock__Content" />
            </div>
          );
        })}
      </div>
    </div>
  );
};

ContentGrid.propTypes = {
  content: PropTypes.object,
  offset: PropTypes.number,
};

ContentGrid.defaultProps = {
  content: {},
};

export default ContentGrid;



// WEBPACK FOOTER //
// ./src/components/ContentGrid.js